import { FunctionComponent } from 'react';

import ErrorGeneric from 'components/SubPages/Error/Generic';

const Index: FunctionComponent = () => <ErrorGeneric />;

export default Index;
